import * as PIXI from "pixi.js";
import genCoordFromAngle from "../../utils/coord/genCoordFromAngle";
import degreeToRadian from "../../utils/math/degreeToRadian";


const PIE_TIMER_RADIUS = 8;
const BG_COLOR = 0xdbf8ff;
const STROKE_COLOR = 0x0195b8;


export default class TimerRendererFactory {
  static formatTimerText(_sec) {
    const oneMin = 60;
    const oneHour = oneMin * 60;
    const hours = Math.floor(_sec / oneHour);
    const remainSec = _sec - hours * oneHour;
    const mins = Math.floor(remainSec / oneMin);
    const seconds = remainSec - mins * oneMin;
    return `${hours > 0 ? `${ hours }h ` : "" }${mins > 0 ? `${ mins }m ` : ""}${ _sec > 0 ? seconds : "0"}s left`
  }
  static drawInitTimerText(timer: PIXI.Text) {
    timer.anchor.set(0, .5);
    timer.style = {
      fill: STROKE_COLOR,
      fontSize: 16
    }
    timer.x = PIE_TIMER_RADIUS * 1.5
  }
  static drawPieTimer(pieTimer: PIXI.Graphics, initSeconds: number, currSeconds: number) {
    const startAngle = -Math.PI / 2;
    const endAngle = -degreeToRadian((currSeconds / initSeconds) * 360) + startAngle; 
    const startCoord = genCoordFromAngle(startAngle, PIE_TIMER_RADIUS);

    pieTimer
      .clear()

      .moveTo(0, 0)
      .circle(0, 0, PIE_TIMER_RADIUS)
      .stroke({ width: 2, color: STROKE_COLOR })

      .moveTo(startCoord.x, startCoord.y)
      .arc(0, 0, PIE_TIMER_RADIUS, startAngle, endAngle, true)
      .lineTo(0, 0)
      .lineTo(startCoord.x, startCoord.y)
      .fill(STROKE_COLOR);
  }
  static drawBg(bg: PIXI.Graphics, textX: number, textWidth: number) {
    const w = PIE_TIMER_RADIUS + textX + textWidth + 16;
    bg
      .clear()
      .roundRect(-14, -14, w, 28, 14)
      .fill({ color: BG_COLOR })
  }
}